export const pollImageType = {
  FILL: "Fill",
  FIT: "Fit"
};
export const dropDownType = {
  US: "US",
  INTERNATIONAL: "International"
};
